	export enum ProcessingInfoEvent {
		ClaimCreation = 1,
		ClaimTransmittalCreation = 2,
		ClaimTransmittalSend = 3
	}
